import { promptLabRepository } from '../repositories/PromptLabRepository';

interface UsageType {
  id: string;
  name: string;
  description: string;
  input_variables: string[];
  is_active: boolean;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
}

interface PromptVariable {
  id: string;
  prompt_id: string;
  var_name: string;
  var_type: string;
  required: boolean;
  default_value: string;
  hint: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
}

interface Prompt {
  id: string;
  type_id: string;
  system_prompt: string;
  user_msg: string | null;
  is_active: boolean;
  instance_id: string;
  chart_lib: string | null;
  version: number;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
}

class PromptLabService {
  private static instance: PromptLabService;

  private constructor() {}

  public static getInstance(): PromptLabService {
    if (!PromptLabService.instance) {
      PromptLabService.instance = new PromptLabService();
    }
    return PromptLabService.instance;
  }

  async getUsageTypes(): Promise<UsageType[]> {
    const data = await promptLabRepository.getUsageTypes();
    return data.filter((type: UsageType) => type.is_active);
  }

  async getPromptVariables(): Promise<any> {
    return await promptLabRepository.getPromptVariables();
  }

  async getPrompts(): Promise<Prompt[]> {
    return await promptLabRepository.getPrompts();
  }

  async getPromptByTypeId(typeId: string): Promise<Prompt | null> {
    const prompts = await this.getPrompts();
    return prompts.find((prompt: Prompt) => prompt.type_id === typeId) || null;
  }

  async savePrompt(data: {
    name: string;
    usage_type_id: string;
    system_prompt: string;
    prompt_type: string;
    is_active: boolean;
    // model_instance_ids: Array<string>;
  }): Promise<any> {
    return await promptLabRepository.savePrompt(data);
  }

  async updatePrompt(promptId: string, data: {
    name: string;
    usage_type_id: string;
    system_prompt: string;
    prompt_type: string;
    is_active: boolean;
    // model_instance_ids: Array<string>;
  }): Promise<any> {
    return await promptLabRepository.updatePrompt(promptId, data);
  }

  async setPromptAsDefault(promptId: string): Promise<any> {
    // This will create a new record with the selected version as default
    return await promptLabRepository.setPromptAsDefault(promptId);
  }

  async createUsageType(data: { name: string; description: string; is_active: boolean }): Promise<any> {
    return await promptLabRepository.createUsageType(data);
  }
}

export const promptLabService = PromptLabService.getInstance();
